/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import breakpoints from "assets/theme/base/breakpoints";

const { text } = colors;
const { size } = typography;

const formLabel = {
  styleOverrides: {
    root: {
      color: text.main,

      // Mobile optimizations
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        fontSize: size.sm,
        fontWeight: 500,
      },
    },
  },
};

export default formLabel;
